import * as React from "react";

export default function Instrctions() {


  return (
    <>
      <div className="page-instruction-section">
        <h3>Instructions:</h3>
        <ul>
          <li>
            Visit https://anuvadini.aicte-india.org/ and Select Image23 Module
          </li>
          <li>
            Click on the upload icon and on the successful upload message Click
            on ‘Proceed’
          </li>
          <li>OCR based Imagine InPasting shall be under progress</li>
          <li>
            On completion, the translated image shall be displayed and can be
            downloaded in JPG and PNG formats
          </li>
        </ul>
      </div>
    </>
  );
}
